import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { fetchUserData } from "../../redux/actions/user.actions";
import ResetPasswordForm from "./components/ResetPasswordForm";
import AuthLayout from "./components/AuthLayout";

const ResetPasswordPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchUserData());
  }, [dispatch]);

  return (
    <AuthLayout title="Choose a new password" subtitle="Your new password must match in both fields.">
      <ResetPasswordForm />
    </AuthLayout>
  );
};

export default ResetPasswordPage;
